import { render, staticRenderFns } from "./ModalDisableFooter.vue?vue&type=template&id=d8024a90&"
import script from "./ModalDisableFooter.vue?vue&type=script&lang=js&"
export * from "./ModalDisableFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports